import React, { SVGProps } from 'react'
const SvgPreviousArrow = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke={props.stroke || 'var(--color-cta)'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M2.454 6.682h9.819a3.273 3.273 0 1 1 0 6.545H9M2.454 6.682l2.91-2.91m-2.91 2.91 2.91 2.91"
    />
  </svg>
)
export default SvgPreviousArrow
